"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navbarLink = void 0;

var _colors = require("./colors");

var _utils = require("./utils");

var navbarLink = {
  colors: {
    dark: {
      colorDisabled: _colors.colors.navbarDarkColorDisabled,
      colorDisabledHoverFocus: _colors.colors.navbarDarkColorDisabled,
      colorActive: _colors.colors.navbarDarkColorActive,
      colorActiveHoverFocus: _colors.colors.navbarDarkColorActive,
      color: _colors.colors.navbarDarkColor,
      colorHoverFocus: _colors.colors.navbarDarkColorHoverFocus
    },
    light: {
      colorDisabled: _colors.colors.navbarLightColorDisabled,
      colorDisabledHoverFocus: _colors.colors.navbarLightColorDisabled,
      colorActive: _colors.colors.navbarLightColorActive,
      colorActiveHoverFocus: _colors.colors.navbarLightColorActive,
      color: _colors.colors.navbarLightColor,
      colorHoverFocus: _colors.colors.navbarLightColorHoverFocus
    },
    default: {
      colorDisabled: _colors.colors.navbarLightColorDisabled,
      colorDisabledHoverFocus: _colors.colors.navbarLightColorDisabled,
      colorActive: _colors.colors.navbarLightColorActive,
      colorActiveHoverFocus: _colors.colors.navbarLightColorActive,
      color: _colors.colors.navbarLightColor,
      colorHoverFocus: _colors.colors.navbarLightColorHoverFocus
    }
  },
  padding: {
    brandTop: '0.3125rem',
    brandBottom: '0.3125rem'
  },
  fontSize: _utils.utils.fontSize
};
exports.navbarLink = navbarLink;